$(document).ready(function () {
    // Function to initialize the map
    function initializeMap() {
        // Check if locations data is available
        if (typeof locations !== 'undefined' && locations.length > 0) {
            // Initialize the map
            var map = L.map('map').setView([54.5, -3.5], 6); // Center the map

            // Define tile layers
            var lightTileLayer = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=cb1_42th_1_6d4ca57a3b29b4f618a993e2', {
                maxZoom: 19,
                attribution: '© OpenStreetMap, © CartoDB'
            });

            var darkTileLayer = L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png?key=cb1_42th_1_6d4ca57a3b29b4f618a993e2', {
                maxZoom: 19,
                attribution: '© OpenStreetMap, © CartoDB'
            });

            // Add the light tile layer initially
            lightTileLayer.addTo(map);

            // Define custom icons for light and dark themes
            var customIconLight = L.icon({
                iconUrl: props.theme_url + '/assets/images/icons/map-pin.svg',  // Your custom icon URL for light theme
                iconSize: [40, 55],            // Icon size
                iconAnchor: [20, 55]  // Center horizontally and align the bottom vertically
            });

            var customIconDark = L.icon({
                iconUrl: props.theme_url + '/assets/images/icons/map-pin-yellow.svg', // Custom icon URL for dark theme
                iconSize: [40, 55],            // Icon size
                iconAnchor: [20, 55]  // Center horizontally and align the bottom vertically
            });

            // Create a marker cluster group
            var markers = L.markerClusterGroup();
            var bounds = L.latLngBounds(); // Create a bounds variable

            // Loop through each location and add a marker with the light icon
            locations.forEach(function (location) {
                if (location.lat === null || location.lng === null) {
                    // console.log(location);
                    return; // Skip invalid locations
                }
                var marker = L.marker([location.lat, location.lng], { icon: customIconLight })
                    .bindPopup(location.popup); // Attach a popup for each marker

                markers.addLayer(marker); // Add marker to cluster group
                bounds.extend(marker.getLatLng()); // Extend bounds to include marker's position
            });

            // Add the marker cluster group to the map
            map.addLayer(markers);

            // Fit the map to the bounds of the markers
            map.fitBounds(bounds);

            // Function to toggle tile layer and marker icons based on theme
            function toggleTileLayer(isDarkTheme) {
                if (isDarkTheme) {
                    map.removeLayer(lightTileLayer);
                    map.addLayer(darkTileLayer);
                    
                    // Update marker icons to dark theme
                    markers.eachLayer(function (marker) {
                        marker.setIcon(customIconDark);
                    });
                } else {
                    map.removeLayer(darkTileLayer);
                    map.addLayer(lightTileLayer);
                    
                    // Update marker icons to light theme
                    markers.eachLayer(function (marker) {
                        marker.setIcon(customIconLight);
                    });
                }
            }

            // Initialize with the current theme
            var isDarkTheme = $('body').hasClass('dark-theme');
            toggleTileLayer(isDarkTheme);

            $(document).on('change', '#dark-toggle', function () {
                var isDarkTheme = $(this).is(':checked');
                toggleTileLayer(isDarkTheme);
            });

        } else {
            console.error('No locations data available.');
        }
    }

    // Check if .b__map exists before initializing the map
    if ( $('.b__map').length > 0 || $('.b__mapText.use-page').length > 0 ) {
        initializeMap();
    }
});

$(document).ready(function () {
    // Function to initialize the single map
    function initializeSingleMap() {
        var singleMapElement = $('#single-map');

        // Check if #single-map element exists and has valid data attributes
        if (singleMapElement.length > 0) {
            var lat = singleMapElement.data('lat');
            var lng = singleMapElement.data('lng');

            if (!lat || !lng) {
                console.error('Latitude or Longitude is missing for the single map.');
                return;
            }

            // Initialize the map
            var map = L.map('single-map').setView([lat, lng], 16); // Center the map on the location at street level

            // Define tile layers
            var lightTileLayer = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=cb1_42th_1_6d4ca57a3b29b4f618a993e2', {
                maxZoom: 19,
                attribution: '© OpenStreetMap, © CartoDB'
            });

            var darkTileLayer = L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png?key=cb1_42th_1_6d4ca57a3b29b4f618a993e2', {
                maxZoom: 19,
                attribution: '© OpenStreetMap, © CartoDB'
            });

            // Add the light tile layer initially
            lightTileLayer.addTo(map);

            // Define custom icons for light and dark themes with larger sizes
            var customIconLight = L.icon({
                iconUrl: props.theme_url + '/assets/images/icons/map-pin.svg', // Your custom icon URL for light theme
                iconSize: [70, 100], // Larger icon size (width, height)
                iconAnchor: [35, 100] // Anchor to bottom-center
            });

            var customIconDark = L.icon({
                iconUrl: props.theme_url + '/assets/images/icons/map-pin-yellow.svg', // Custom icon URL for dark theme
                iconSize: [70, 100], // Larger icon size (width, height)
                iconAnchor: [35, 100] // Anchor to bottom-center
            });

            // Add a single marker with the light icon
            var marker = L.marker([lat, lng], { icon: customIconLight });
            marker.addTo(map);

            marker.on('click', function(){
                var url = 'https://www.google.com/maps/dir/?api=1&destination=' + lat + ',' + lng;
                window.open(url, '_blank'); // Opens the link in a new tab
            });

            // Function to toggle tile layer and marker icon based on theme
            function toggleTileLayer(isDarkTheme) {
                if (isDarkTheme) {
                    map.removeLayer(lightTileLayer);
                    map.addLayer(darkTileLayer);
                    marker.setIcon(customIconDark); // Update marker to dark theme icon
                } else {
                    map.removeLayer(darkTileLayer);
                    map.addLayer(lightTileLayer);
                    marker.setIcon(customIconLight); // Update marker to light theme icon
                }
            }

            // Initialize with the current theme
            var isDarkTheme = $('body').hasClass('dark-theme');
            toggleTileLayer(isDarkTheme);

            $(document).on('change', '#dark-toggle', function () {
                var isDarkTheme = $(this).is(':checked');
                toggleTileLayer(isDarkTheme);
            });
        }
    }

    // Initialize the single map
    initializeSingleMap();
});

